export const DEMO_PRIVACY_MODE_STORAGE_KEY = 'cv-demo-privacy-mode';

/** Minimum typed characters in an autocomplete before names are revealed in demo privacy mode. */
export const DEMO_PRIVACY_AUTOCOMPLETE_MIN_SEARCH_LENGTH = 5;

export const demoPrivacyBlurStyles = {
  filter: 'blur(4px)',
  userSelect: 'none',
  display: 'inline-block',
  maxWidth: '100%',
  verticalAlign: 'inherit',
  marginInline: '-8px',
  paddingInline: '8px',
  WebkitMaskImage: 'linear-gradient(90deg, #000 calc(100% - 10px), transparent 100%)',
  maskImage: 'linear-gradient(90deg, #000 calc(100% - 10px), transparent 100%)',
} as const;

/** Blur for form inputs — no truncation mask, so values stay visible (just obscured). */
export const demoPrivacyInputBlurStyles = {
  filter: 'blur(4px)',
  userSelect: 'none',
} as const;
